import React from 'react';
import { url } from '../../weburl';
import axios from 'axios';
import { Community_Nav } from '../community_nav';
import NewlyRegisteredSwiper from './swiper_newly_registered';
import Navbar from '../../home/navbar';

import Footer from '../../home/footer';
import NewlyImageGallery from './newly_gallery';


export class NewlyRegistered extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            dog: {
                name: ''
            }
        }
    }


    render() {
        return (

            <div className='view_height_100'>
                {/* <Navbar/> */}
                <Community_Nav />
                <div className='row align-items-start justify-content-center view_height_100 bg-dark'>
                    <div className='col-md-12 bg-dark'>
                        <NewlyImageGallery />
                    </div>

                </div>
            </div>
        )
    }
}